import { get_token, get_user_details } from "@/router";
import { CART_UPDATED_EVENT, create_checkout_slug } from "@/components/cart/cart_helper";
/* global bootstrap */
export default {
  name: "Cart",
  data: () => ({
    cartItems: [],
    token_exists: false,
    base_profile_id: '',
    cartBadgeCount: 0,
    user_details: null,
    cart_updated_handler: null,
  }),

  mounted() {
    this.token_exists = get_token();
    this.base_profile_id = this.$route.query.base;
    this.load_cart();
    this.user_details = get_user_details();
    this.cart_updated_handler = () => this.load_cart();
    window.addEventListener(CART_UPDATED_EVENT, this.cart_updated_handler);
  },

  beforeUnmount() {
    if (this.cart_updated_handler) {
      window.removeEventListener(CART_UPDATED_EVENT, this.cart_updated_handler);
    }
  },

  watch: {
    // Watch route query for profile changes
    '$route.query.base'(newBase) {
      if (newBase && newBase !== this.base_profile_id) {
        this.base_profile_id = newBase;
      }
    },
  },

  methods: {
    format_attribute_text(value) {
      return String(value || "")
        .trim()
        .split(/[\s_-]+/)
        .filter(Boolean)
        .map((part) => part.charAt(0).toUpperCase() + part.slice(1))
        .join(" ");
    },
    // Load cart using shared utility
    load_cart() {
      if (!this.token_exists) return;

      let url = `${process.env.VUE_APP_BACKEND_API_URL}/company_management/fetch_cart/`;

      $.ajax({
        url: url,
        type: 'POST',
        headers: {
          "Authorization": `Token ${get_token()}`,
          "Content-Type": "application/json"
        },
        data: JSON.stringify({ base_profile_id: this.base_profile_id }),

        success: (data) => {
          if (data.status === "success") {
            this.cartItems = data.carts;
            if (this.base_profile_id) {
              this.cartBadgeCount = this.cartItems.total_items || 0;
            } else {
              this.cartBadgeCount = data.total_carts || 0;
            }

          }
        },
        error: (error) => {
          console.error("AJAX error fetching cart:", error);
        }
      });
    },

    openCart() {
      const offcanvasEl = document.getElementById('cartOffcanvas');
      const bsOffcanvas = new bootstrap.Offcanvas(offcanvasEl);
      bsOffcanvas.show();
    },

    async increaseQuantity(item) {
      await this.updateQuantity(item, 'increase');
    },
    async decreaseQuantity(item) {
      await this.updateQuantity(item, 'decrease');
    },
    async updateQuantity(item, action) {
      const oldQty = Number(item.quantity) || 0;

      const response = await $.ajax({
        url: `${process.env.VUE_APP_BACKEND_API_URL}/company_management/update_cart_item_quantity/`,
        type: 'POST',
        headers: {
          "Authorization": `Token ${get_token()}`,
          "Content-Type": "application/json"
        },
        data: JSON.stringify({ cart_item_id: item.id, action }),
      });

      if (response.status === "success") {
        const responseQty = Number(response.quantity);
        const newQty = Number.isFinite(responseQty)
          ? responseQty
          : Math.max(action === 'increase' ? oldQty + 1 : oldQty - 1, 0);

        if (newQty > 0) {
          item.quantity = newQty;
          this.update_local_cart_totals(item, oldQty, newQty, response);
        } else {
          item.quantity = 0;
          this.update_local_cart_totals(item, oldQty, newQty, response);
          this.remove_local_cart_item(item);
        }
      } else {
        console.error("Failed to update quantity:", response.message);
      }
    },

    remove_local_cart_item(item) {
      if (this.base_profile_id) {
        this.cartItems.items = (this.cartItems.items || []).filter(i => i.id !== item.id);
        return;
      }

      this.cartItems = (this.cartItems || [])
        .map(cart => ({
          ...cart,
          items: (cart.items || []).filter(i => i.id !== item.id)
        }))
        .filter(cart => cart.items.length);

      this.cartBadgeCount = Array.isArray(this.cartItems) ? this.cartItems.length : 0;
    },

    find_cart_for_item(item) {
      if (this.base_profile_id) {
        return this.cartItems;
      }

      return (this.cartItems || []).find(cart =>
        (cart.items || []).some(cartItem => cartItem.id === item.id)
      );
    },

    update_local_cart_totals(item, oldQty, newQty, response = {}) {
      const cart = this.find_cart_for_item(item);

      if (cart) {
        const backendTotal = response.cart_total_amount ?? response.total_amount ?? response.cart_total;
        cart.total_amount = backendTotal !== undefined
          ? backendTotal
          : (cart.items || []).reduce((total, cartItem) => {
              const price = Number(cartItem.price) || 0;
              const quantity = Number(cartItem.quantity) || 0;
              return total + (price * quantity);
            }, 0);
      }

      if (this.base_profile_id) {
        const totalItems = (this.cartItems.items || []).reduce((total, cartItem) => {
          return total + (Number(cartItem.quantity) || 0);
        }, 0);
        this.cartItems.total_items = totalItems;
        this.cartBadgeCount = totalItems;
      } else if (newQty === 0 && oldQty > 0) {
        this.cartBadgeCount = Array.isArray(this.cartItems) ? this.cartItems.length : 0;
      }
    },

    removeCartItem(item) {
      $.ajax({
        url: `${process.env.VUE_APP_BACKEND_API_URL}/company_management/delete_cart_item/`,
        type: "POST",
        headers: {
          "Authorization": `Token ${get_token()}`,
          "Content-Type": "application/json",
        },
        data: JSON.stringify({ cart_item_id: item.id }),
        success: (data) => {
          if (data.status === "success") {
            this.load_cart(); // Use utility instead of inline AJAX
          } else {
            console.error("Failed to remove item:", data.message);
          }
        },
        error: (err) => {
          console.error("Error removing cart item:", err);
        },
      });
    },
    initiate_checkout(cart_id) {
      this.$router.push({
        name: 'cart_checkout',
        params: { checkout_slug: create_checkout_slug({ cart: cart_id }) }
      })

    },

    format_money(value) {
      if (!value) return '0';
      return Number(value).toLocaleString('en-ZA', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
      });
    },
    get_attribute_label(attribute) {
      return attribute?.attribute_type;
    },
    get_attribute_value(attribute) {
      return attribute?.label;
    },
    get_item_attributes(item) {
      const rawAttributes =
        item?.attributes || [];

      return rawAttributes
        .map((attribute) => {
          const rawLabel = this.get_attribute_label(attribute);
          const rawValue = this.get_attribute_value(attribute);

          const label = this.format_attribute_text(rawLabel);
          const value = this.format_attribute_text(rawValue);

          if (!label || !value) {
            return null;
          }

          return { label, value };
        })
        .filter(Boolean);
    }
  }
};
